const filterRoutesByRole = (routes, role) => {
  return routes
    .filter((route) => {
      if (route.roles) {
        return route.roles.includes(role);
      }
      return true;
    })
    .map((route, index) => {
      if (route.children) {
        return {
          ...route,
          key: route.key || route.path || `route-${index}`, // Assign a unique key
          children: filterRoutesByRole(route.children, role),
        };
      }
      return route;
    });
};

export default filterRoutesByRole;
